import { render, staticRenderFns } from "./GameAnalysisPage.vue?vue&type=template&id=fefd39d0&"
import script from "./GameAnalysisPage.vue?vue&type=script&lang=js&"
export * from "./GameAnalysisPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports